import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Feature from "../components/Features";
import ServicePage from "../components/ServicePage";
import ChooseUs from "../components/ChooseUs";
import HeroSection from "../components/HeroSlider";
import Services from "./ServicesPage";
import ContactUsForm from "../components/ContactUsForm";
import ScrollProgress from "../components/ScrollProgress";
import Testimonals from "../components/Testimonals";
import OurClients from "../components/OurClients";
import SectionHero from "../herosection/SectionHero";
import SectionCards from "../herosection/SectionCards";


const HomePage = () => {
  return (
    <div className="bg-white text-black">
      <ScrollProgress />
      <Header />
      <main className="">
        {/* <HeroSection /> */}
        <SectionHero/>
        <SectionCards/>
        {/* <ServicePage /> */}
        <ChooseUs />
        <Feature />
        <OurClients />
        <Testimonals />
        <ContactUsForm />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
